import { Button, ButtonGroup, ClickAwayListener, Grow, MenuItem, MenuList, Paper, Popper } from "@material-ui/core";
import { FilterList } from "@material-ui/icons";
import useText from "constants/text";
import React from "react";
import { useStyles } from "./style";

export interface Action {
  key: string;
  label: string;
  abilities?: string[];
}

export interface FilterGroupProps {
  actions: Action[];
  onClick: (key: string) => void;
  name?: string;
  className?: string;
}

const FilterGroup: React.FC<FilterGroupProps> = ({ actions, onClick, name }): React.ReactElement => {
  const anchorRef = React.useRef<HTMLDivElement>(null);
  const [open, setOpen] = React.useState(false);
  const { text } = useText();
  const styles = useStyles();

  const handleToggle = () => {
    setOpen((prevOpen) => !prevOpen);
  };

  const handleClick = (key: string) => {
    onClick(key);
    setOpen(false);
  };

  const handleClose = (event: React.MouseEvent<Document, MouseEvent>) => {
    if (anchorRef.current && anchorRef.current.contains(event.target as HTMLElement)) {
      return;
    }
    setOpen(false);
  };

  return (
    <>
      <ButtonGroup
        className={styles.buttonGroup}
        variant="contained"
        color="primary"
        ref={anchorRef}
        aria-label="split button"
      >
        <Button
          className={styles.button}
          aria-label="more"
          aria-controls="customized-menu"
          aria-haspopup="true"
          variant="outlined"
          endIcon={<FilterList />}
          onClick={handleToggle}
        >
          <span className={styles.filterStyle}>{name || `${text.parcel.filtrer_text}`} </span>
        </Button>
      </ButtonGroup>
      <Popper open={open} anchorEl={anchorRef.current} role={undefined} transition style={{ zIndex: 2 }}>
        {({ TransitionProps, placement }) => (
          <Grow
            {...TransitionProps}
            style={{
              transformOrigin: placement === "bottom" ? "center top" : "center bottom",
            }}
          >
            <Paper>
              <ClickAwayListener onClickAway={handleClose}>
                <MenuList id="split-button-menu">
                  {actions.map((action) => (
                    <MenuItem style={{ padding: 0 }}>
                      <Button className={styles.optionStyle} onClick={() => handleClick(action.key)}>
                        {action.label}
                      </Button>
                    </MenuItem>
                  ))}
                </MenuList>
              </ClickAwayListener>
            </Paper>
          </Grow>
        )}
      </Popper>
    </>
  );
};

export default FilterGroup;
